import React from 'react';
import { reduxForm } from 'redux-form';
import LeaseTermsForm from './LeaseTermsForm';
import LeadCardPicker from './LeadCardPicker';

const FORM_NAME = 'add_lead_form';
class InviteLeadForm extends React.Component {
  render() {
    const props = this.props;

    return (
      <form onSubmit={props.handleSubmit}>
        {this.renderLeadCardPicker()}
        <LeaseTermsForm
          getUnits={props.getUnits}
          getCurrentLeasesOfUnit={props.getCurrentLeasesOfUnit}
          clearCurrentLeasesOfUnit={props.clearCurrentLeasesOfUnit}
          currentLeasesOfUnit={props.currentLeasesOfUnit}
          properties={props.properties}
          units={props.units}
          unitDepositAmount={props.unitDepositAmount}
          unitMarketRent={props.unitMarketRent}
          unitAbsoluteRent={props.unitAbsoluteRent}
          unitMarketRentSixMonths={props.unitMarketRentSixMonths}
          getUnitDetails={props.getUnitDetails}
          disableLeaseWizardSelections={props.disableLeaseWizardSelections}
          onlyYardiBasedProperties={props.onlyYardiBasedProperties}
          transferApplication={props.transferApplication}
        />
      </form>
    );
  }

  renderLeadCardPicker = () => {
    if (this.props.transferApplication) return;

    return (
      <LeadCardPicker
        formName={FORM_NAME}
        properties={this.props.properties}
        getUnits={this.props.getUnits}
        trafficSources={this.props.trafficSources}
        getCurrentLeasesOfUnit={this.props.getCurrentLeasesOfUnit}
        clearCurrentLeasesOfUnit={this.props.clearCurrentLeasesOfUnit}
        getUnitDetails={this.props.getUnitDetails}
      />
    );
  };
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  initialValues: {
    coapplicants_in_application: true,
    create_prorated_charge: true,
    collect_first_months_with_deposit: false,
  },
})(InviteLeadForm);
